import {
  CreateSubscriptionPlanInput,
  CurrencyEnum,
  FileTypeEnum,
  SubscriptionPlanFullFragment,
  UpdateSubscriptionPlanInput,
  UploadTypeEnum,
} from "@/generated/generated-hooks";

export const getSubscriptionPlanInput = (
  channelIds = [] as string[],
): CreateSubscriptionPlanInput => {
  /* @TODO: use real data */
  return {
    title: "",
    price: null,
    image: null,
    content: { serialized: "", stringifyed: "" },
    benefits: [],
    currency: CurrencyEnum.Usd,
    channelIds,
  };
};

export const getUpdateSubscriptionPlanInput = (
  data: SubscriptionPlanFullFragment,
): UpdateSubscriptionPlanInput => {
  /* @TODO: use real data */
  const {
    _id,
    slug,
    title,
    channelIds,
    subscriptionPlanStatus,
    content,
    image,
    price,
    plan,
    benefits,
    currency,
  } = data;
  const initialImage = image
    ? {
        url: image.url,
        _id: "",
        uploadType: UploadTypeEnum.Local,
        fileType: FileTypeEnum.Image,
      }
    : null;

  return {
    _id,
    slug,
    title,
    channelIds,
    subscriptionPlanStatus,
    image: initialImage,
    content: {
      serialized: content.serialized,
      stringifyed: content.stringifyed,
    },
    price,
    plan,
    benefits,
    currency,
  };
};
